
  export default {
    name: 'SectionBreadcrumbs',
    props: {
      section: {
        type: Object,
        required: true,
        default: () => {},
      },
    },
    data() {
      return {
        items: {},
      };
    },
    created() {
      if (this.section.show_component_breadcrumbs) {
        this.items = this.section.breadcrumbs;
      } else {
        this.items = this.section.items;
      }
    },
  };
